import { useEffect } from 'react'
import { useNavigate, useSearchParams } from 'react-router-dom'
import { useCityContext } from '@contexts/LocationContext'
import { useAuth } from '@contexts/AuthContext'
import { Loading } from '@components' // Assuming Loading component is available
import storage from '@services/storage'

const GoogleCallback = () => {
  const navigate = useNavigate()
  const { city } = useCityContext()
  const [searchParams] = useSearchParams()
  const { handleGoogleCallback, isAuthenticated, error, loading } = useAuth()

  useEffect(() => {
    const accessToken = searchParams.get('access_token')
    const firebaseToken = searchParams.get('firebase_custom_token')

    if (accessToken && firebaseToken) {
      // If tokens are present, attempt to process the callback
      handleGoogleCallback(accessToken, firebaseToken)
    } else if (!loading && !isAuthenticated) {
      // If not loading, not authenticated, and no tokens found,
      // it means the callback URL was visited without the expected parameters or there was an error.
      // Redirect to login or show an error.
      if (error) {
        // AuthContext already shows a toast, so just redirect
        navigate(`/${city?.slug || ''}/login`, { replace: true })
      } else {
        // No tokens and no error, likely an invalid callback or direct access
        navigate(`/${city?.slug || ''}/login`, { replace: true })
      }
    }
  }, [searchParams, handleGoogleCallback, isAuthenticated, error, loading, navigate])

  useEffect(() => {
    if (isAuthenticated) {
      // Redirect to the stored 'from' path or home after successful authentication
      const from = storage.getItem('redirect_after_login') || '/'
      storage.removeItem('redirect_after_login') // Clean up
      navigate(from, { replace: true })
    }
  }, [isAuthenticated, navigate])

  if (loading) {
    return (
      <div className="google-callback-page">
        <Loading size="lg" text="Processando login com Google..." />
      </div>
    )
  }

  // If not loading and not authenticated, and didn't redirect, something went wrong.
  // The useEffect above should handle redirects to login on error/failure.
  return null // Or a simple message/spinner if loading state isn't enough
}

export default GoogleCallback
